import { ApiEngineLocations, EngineLocation, EngineLocations, ApiDepartments, APIDepartment, UIDepartment, UIDepartments, LMPostDepartments, LMDepartmentLocation } from "./types";
import { ListingType, ListingUI, ListingAPI } from 'features/Dealers/Listings/state/types';




export const parseAPILMdepartments = (apiLMDepartments: ApiDepartments): UIDepartments => {
    return {
        urlcms: apiLMDepartments.urlcms,
        urlsupport: apiLMDepartments.urlsupport,
        departments: apiLMDepartments.departments.map(parseAPIdepartment)
    }
}

export const parseAPIdepartment = (apiDepartment: APIDepartment): UIDepartment => {
    return {
        name: apiDepartment.departmentName,
        url: apiDepartment.departmentUrl,
    }
}


export const parseAPIEngineLocations = (apiLMEngineLocations: ApiEngineLocations): EngineLocations => {
    return {
        locations: apiLMEngineLocations.locations
    }
}



export const parseUIEngineLocations = (lmEngineLocations: EngineLocations): ApiEngineLocations => {
    return {
        locations: lmEngineLocations.locations
    }
}